<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h16"><span class="th11">Acknowledgments</span></h1>
<p class="p0"><img alt="img2.png" src="images/img2.png"/></p>
<p class="p12"> </p>
<p class="p13">A special thank-you to Jesse Jackman for the use of the fantastic cover image. You were amazingly generous!</p>
<p class="p13"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007.vue?c5910296